<template>
  <div class="d-flex question-wrapper" style="flex: 0 0 auto">
    <input
      type="file"
      ref="fileInput"
      class="hidden"
      accept=".csv"
      @change="handleClick"
    />
    <input
      type="file"
      ref="fileInputCheckbox"
      class="hidden"
      accept=".csv"
      @change="handleClickCheckboxes"
    />
    <div class="mr-3">
      <div class="drag-handle sticky-menu-2" :class="sticking2">
        <h1 class="mb-0 text-center pt-4">
          <i class="fas fa-grip-vertical"></i>
        </h1>
      </div>
      <div
        class="text-center btn-panel mt-4 sticky-menu"
        :class="{ sticking }"
        style="margin-right: 8px"
      >
        <div @click="onNewQuestion ? onNewQuestion() : () => {}">
          <vx-tooltip text="Add Question">
            <i class="fas fa-plus-circle"></i>
          </vx-tooltip>
        </div>
        <div @click="onCopyQuestion ? onCopyQuestion() : () => {}">
          <vx-tooltip text="Duplicate">
            <i class="far fa-copy"></i>
          </vx-tooltip>
        </div>
        <div
          @click="onAddTitleDescription ? onAddTitleDescription() : () => {}"
        >
          <vx-tooltip text="Title and Description">
            <i class="vs-icon material-icons text-red">format_size</i>
          </vx-tooltip>
        </div>
        <!-- <div @click="onAddImage ? onAddImage() : () => {}">
          <i class="vs-icon material-icons text-red">insert_photo</i>
        </div> -->
        <div @click="onAddVideo ? onAddVideo() : () => {}">
          <vx-tooltip text="Video">
            <i class="fab fa-youtube"></i>
          </vx-tooltip>
        </div>
        <div
          @click="onAddDivider ? onAddDivider() : () => {}"
          style="transform: translateY(-10px)"
        >
          <vx-tooltip text="Divider">
            <i class="far fa-window-minimize"></i>
          </vx-tooltip>
        </div>
        <div @click="onDelete ? onDelete() : () => {}">
          <vx-tooltip text="Delete">
            <i class="fas fa-trash-alt"></i>
          </vx-tooltip>
        </div>
        <div @click="onMoveUp ? onMoveUp() : () => {}">
          <vx-tooltip text="Move Up">
            <i class="fas fa-arrow-up"></i>
          </vx-tooltip>
        </div>
        <div @click="onMoveDown ? onMoveDown() : () => {}">
          <vx-tooltip text="Move Down">
            <i class="fas fa-arrow-down"></i>
          </vx-tooltip>
        </div>
      </div>
    </div>
    <div>
      <div class="question-container">
        <!-- Left side: Question and Question Type -->
        <div v-if="questionType != 'divider'" class="left-side">
          <!-- Question Input -->
          <vs-input
            id="question"
            v-model="question"
            @change="updateQuestion"
            class="mb-3"
            :placeholder="
              questionType == 'title_description' ? 'Title' : 'Question'
            "
            style="min-width: 300px"
            size="large"
          ></vs-input>
        </div>

        <!-- Right side: Hide and Required -->
        <div class="right-side mx-3">
          <!-- Question Type Dropdown with Vuesax styling -->
          <div id="questionType" icon="list" class="mb-3">
            <b-form-select
              v-model="questionType"
              id="questionType"
              class="bootstrap-dropdown"
              style="height: 55px"
              @change="handleQuestionTypeChange"
              size="lg"
            >
              <optgroup
                v-for="group in questionTypes"
                :label="group.label"
                :key="group.text"
              >
                <option
                  v-for="option in group.options"
                  :key="option.slug"
                  :label="option.label"
                  :value="option.slug"
                ></option>
              </optgroup>
            </b-form-select>
          </div>
        </div>

        <div class="show-required-container">
          <!-- Hide Switch -->
          <label for="show" class="mr-1">Show</label>
          <vs-switch
            id="show"
            v-model="show"
            @change="updateQuestion"
            class="mb-3"
          ></vs-switch>

          <!-- Required Switch -->
          <label for="required" class="ml-3 mr-1">Required</label>
          <vs-switch
            id="required"
            v-model="required"
            @change="updateQuestion"
            class="mb-3"
          ></vs-switch>
        </div>
      </div>
      <br />

      <div v-if="is_description_enabled">
        <!-- <label>Description</label> -->
        <vs-input
          v-model="description"
          @change="updateQuestion"
          class="mb-3 w-full"
          placeholder="Description (Optional)"
          style="min-width: 600px"
          block
        ></vs-input>
      </div>
      <!-- Radio Options for Multiple choice question type -->
      <div v-if="questionType === 'radio'" id="radioOptionsGroup" class="mb-3">
        <div class="radio-options-container">
          <draggable
            :list="radioOptions"
            :options="{
              handle: '.radio-drag-handle',
              animation: 300
            }"
            tag="div"
          >
            <div
              v-for="(radioOption, index) in radioOptions"
              :key="index"
              class="radio-option mb-3"
              v-if="!isOtherOption(index)"
            >
              <div class="radio-drag-handle">
                <h3 class="mb-0"><i class="fas fa-grip-vertical"></i></h3>
              </div>
              <vx-tooltip
                v-if="radioOptions[index].value == default_answer"
                text="This option will be pre-selected"
                class=""
                position="top"
              >
                <div @click="default_answer = ''">
                  <vs-radio
                    style="pointer-events: none"
                    v-model="default_answer"
                    :vs-value="radioOptions[index].value"
                    disabled
                  >
                  </vs-radio>
                </div>
              </vx-tooltip>
              <vs-radio
                v-else
                v-model="default_answer"
                :vs-value="radioOptions[index].value"
              >
              </vs-radio>
              <vs-input
                :ref="'radio-' + index"
                v-model="radioOptions[index].value"
                :placeholder="'Option ' + (index + 1)"
                :class="!isRadioDuped(index) ? 'mb-0' : ''"
                class="choice"
                :danger="isRadioDuped(index)"
                danger-text="Option already exists"
                val-icon-danger="error_outline"
                @change="updateQuestion"
                v-on:keyup.enter="addRadioOption(index)"
              ></vs-input>

              <div
                v-if="showRemoveRadioButton"
                @click="removeRadioOption(index)"
                class="remove-button mx-3"
              >
                <i class="fas fa-times"></i>
              </div>

              <ConditionSetting
                v-if="value.condition_enabled"
                :onChanged="updateQuestion"
                :condition.sync="radioOptions[index].actions"
                :questions="allQuestionsNoThis"
              />
            </div>
          </draggable>
          <!-- "Other" option always displayed at the end -->
          <div v-if="showOtherOption" class="radio-option">
            <vs-input
              v-model="otherOption.value"
              placeholder="Other"
              disabled
              class="mb-3"
              @change="updateQuestion"
            ></vs-input>
            <div
              v-if="showRemoveOtherButton"
              @click="removeOtherOption"
              class="remove-button mx-3"
            >
              <i class="fas fa-times"></i>
            </div>
          </div>
        </div>
        <vs-button
          @click="addRadioOption()"
          class="add-option-button ml-0 px-2"
          type="flat"
          >Add Option</vs-button
        >
        <span class="pl-2" v-if="showAddOtherButton">or</span>
        <vs-button
          v-if="showAddOtherButton"
          @click="addOtherOption"
          class="add-option-button px-2"
          type="flat"
        >
          Add Other
        </vs-button>
        <span class="pl-2">or</span>
        <vs-button
          @click="$refs.fileInput.click()"
          class="add-option-button px-2"
          type="flat"
        >
          Upload Options
        </vs-button>

        <!-- <div class="my-3">
          <b-form-select
            @change="updateQuestion"
            v-model="default_answer"
            :options="radioOptionsForSelectedOption"
          ></b-form-select>
        </div> -->
      </div>

      <!-- Checkbox Options for Multiple choice question type -->
      <div
        v-else-if="questionType === 'checkbox'"
        id="checkboxOptionsGroup"
        class="mb-3"
      >
        <div class="d-flex">
          <div>
            <label for="minCheckboxSelected">Min Selected</label>
            <vs-input
              type="number"
              v-model="minCheckboxSelected"
              id="minCheckboxSelected"
              class="mb-3"
              :min="0"
              @input="updateQuestion"
            ></vs-input>
          </div>
          <div class="ml-5">
            <label for="maxCheckboxSelected" class="">Max Selected</label>
            <vs-input
              type="number"
              v-model="maxCheckboxSelected"
              id="maxCheckboxSelected"
              class="mb-3"
              :min="0"
              @input="updateQuestion"
            ></vs-input>
          </div>
        </div>
        <div class="checkbox-options-container">
          <draggable
            v-model="checkboxOptions"
            :options="{
              animation: 300,
              handle: '.radio-drag-handle'
            }"
            tag="div"
          >
            <div
              v-for="(checkboxOption, index) in checkboxOptions"
              :key="index"
              class="mb-3"
            >
              <div class="radio-drag-handle checkbox-option">
                <h3 class="mb-0"><i class="fas fa-grip-vertical"></i></h3>
                <vx-tooltip
                  v-if="
                    default_answer == checkboxOptions[index].value ||
                      (default_answer &&
                        default_answer.includes &&
                        default_answer.includes(checkboxOptions[index].value))
                  "
                  text="This option will be pre-selected"
                  class=""
                  position="top"
                >
                  <div>
                    <vs-checkbox
                      style="pointer-events: none"
                      :vs-value="checkboxOptions[index].value"
                      :value="true"
                      disabled
                    >
                    </vs-checkbox>
                  </div>
                </vx-tooltip>
                <vs-checkbox
                  @click="default_answer = checkboxOptions[index].value"
                  v-else
                  :vs-value="checkboxOptions[index].value"
                  disabled
                >
                </vs-checkbox>
                <vs-input
                  :ref="'checkbox-' + index"
                  v-model="checkboxOptions[index].value"
                  :placeholder="'Option ' + (index + 1)"
                  :class="!isCheckboxDuped(index) ? 'mb-0' : ''"
                  class="choice"
                  :danger="isCheckboxDuped(index)"
                  danger-text="Option already exists"
                  val-icon-danger="error_outline"
                  @change="updateQuestion"
                  v-on:keyup.enter="addCheckboxOption(index)"
                ></vs-input>
                <div
                  v-if="showRemoveCheckboxButton"
                  @click="removeCheckboxOption(index)"
                  class="remove-button mx-3"
                >
                  <i class="fas fa-times"></i>
                </div>
                <ConditionSetting
                  v-if="value.condition_enabled"
                  :onChanged="updateQuestion"
                  :condition.sync="checkboxOptions[index].actions"
                  :questions="allQuestionsNoThis"
                />
              </div>
            </div>
          </draggable>
          <div v-if="showCheckboxOtherOption" class="radio-option">
            <vs-input
              v-model="otherOption.value"
              placeholder="Other"
              disabled
              class="mb-3"
              @change="updateQuestion"
            ></vs-input>
            <div
              v-if="showRemoveOtherButton"
              @click="removeCheckboxOtherOption"
              class="remove-button mx-3"
            >
              <i class="fas fa-times"></i>
            </div>
          </div>
        </div>
        <vs-button
          @click="addCheckboxOption()"
          class="add-option-button ml-0 px-2"
          type="flat"
          >Add Option</vs-button
        >
        <span class="pl-2" v-if="showAddCheckboxOtherButton">or</span>
        <vs-button
          v-if="showAddCheckboxOtherButton"
          @click="addCheckboxOtherOption"
          class="add-option-button px-2"
          type="flat"
        >
          Add Other
        </vs-button>
        <span class="pl-2">or</span>
        <vs-button
          @click="$refs.fileInputCheckbox.click()"
          class="add-option-button px-2"
          type="flat"
        >
          Upload Options
        </vs-button>
        <!-- <div class="my-3">
          <b-form-select
            @change="updateQuestion"
            v-model="default_answer"
            :options="checkboxOptionsForSelectedOption"
          ></b-form-select>
        </div> -->
      </div>

      <!-- Options for Select (Dropdown) question type -->
      <div
        v-else-if="questionType === 'select'"
        id="selectOptionsGroup"
        class="mb-3"
      >
        <div class="select-options-container">
          <draggable
            v-model="selectOptions"
            :options="{
              animation: 300,
              handle: '.radio-drag-handle'
            }"
            tag="div"
          >
            <div
              v-for="(selectOption, index) in selectOptions"
              :key="index"
              class="select-option mb-3"
            >
              <div class="radio-drag-handle">
                <h3 class="mb-0"><i class="fas fa-grip-vertical"></i></h3>
              </div>
              <vx-tooltip
                v-if="selectOptions[index].value == default_answer"
                text="This option will be pre-selected"
                class=""
                position="top"
              >
                <div @click="default_answer = ''">
                  <vs-radio
                    style="pointer-events: none"
                    v-model="default_answer"
                    :vs-value="selectOptions[index].value"
                    disabled
                  >
                  </vs-radio>
                </div>
              </vx-tooltip>
              <vs-radio
                v-else
                v-model="default_answer"
                :vs-value="selectOptions[index].value"
              >
              </vs-radio>
              <vs-input
                :ref="'select-' + index"
                v-model="selectOptions[index].value"
                :placeholder="'Option ' + (index + 1)"
                :class="!isSelectDuped(index) ? 'mb-0' : ''"
                class="choice"
                :danger="isSelectDuped(index)"
                danger-text="Option already exists"
                val-icon-danger="error_outline"
                @change="updateQuestion"
                v-on:keyup.enter="addSelectOption(index)"
              ></vs-input>
              <div
                v-if="showRemoveDropdownButton"
                @click="removeSelectOption(index)"
                class="remove-button mx-3"
              >
                <i class="fas fa-times"></i>
              </div>

              <ConditionSetting
                v-if="value.condition_enabled"
                :onChanged="updateQuestion"
                :condition.sync="selectOptions[index].actions"
                :questions="allQuestionsNoThis"
              />
            </div>
          </draggable>
          <div v-if="showDropdownOtherOption" class="radio-option">
            <vs-input
              v-model="otherOption.value"
              placeholder="Other"
              disabled
              class="mb-3"
              @change="updateQuestion"
            ></vs-input>
            <div
              v-if="showRemoveOtherButton"
              @click="removeDropdownOtherOption"
              class="remove-button mx-3"
            >
              <i class="fas fa-times"></i>
            </div>
          </div>
        </div>
        <vs-button
          @click="addSelectOption()"
          class="add-option-button ml-0"
          type="flat"
          >Add Option</vs-button
        >
        <span class="pl-2" v-if="showAddDropdownOtherButton">or</span>
        <vs-button
          v-if="showAddDropdownOtherButton"
          @click="addDropdownOtherOption"
          class="add-option-button px-2"
          type="flat"
        >
          Add Other
        </vs-button>
        <div class="my-3">
          <b-form-select
            @change="updateQuestion"
            v-model="default_answer"
            :options="selectOptionsForSelectedOption"
          ></b-form-select>
        </div>
      </div>

      <!-- Min and Max for Rank question type -->
      <div v-else-if="questionType === 'rate'" class="mb-3">
        <label for="rateMin">Pre-filled answer</label>
        <vs-input
          type="number"
          v-model="default_answer"
          :min="rateMin"
          :max="rateMax"
          class="mb-3"
        ></vs-input>

        <label for="rateMin">Min Rank</label>
        <vs-input
          type="number"
          v-model="rateMin"
          id="rateMin"
          class="mb-3"
        ></vs-input>

        <label for="rateMax" class="ml-3">Max Rank</label>
        <vs-input
          type="number"
          v-model="rateMax"
          id="rateMax"
          class="mb-3"
        ></vs-input>
      </div>

      <!-- Min and Max for Rank question type -->
      <div v-else-if="questionType === 'file_upload'" class="mb-3">
        <!-- <label>Allow only specific file types</label>
        <vs-switch v-model="isSpecificFileTypes" />
        <br /> -->
        <div style="max-width: 600px;">
          <div class="vx-row mb-6">
            <div class="vx-col w-1/2 mb-2">
              <vs-checkbox
                @change="updateQuestion()"
                :vs-value="'document'"
                v-model="specificFileTypes"
              >
                Document
              </vs-checkbox>
            </div>
            <div class="vx-col w-1/2 mb-2">
              <vs-checkbox
                @change="updateQuestion()"
                :vs-value="'presentation'"
                v-model="specificFileTypes"
              >
                Presentation
              </vs-checkbox>
            </div>
            <div class="vx-col w-1/2 mb-2">
              <vs-checkbox
                @change="updateQuestion()"
                :vs-value="'spreadsheet'"
                v-model="specificFileTypes"
              >
                Spreadsheet
              </vs-checkbox>
            </div>
            <div class="vx-col w-1/2 mb-2">
              <vs-checkbox
                @change="updateQuestion()"
                :vs-value="'drawing'"
                v-model="specificFileTypes"
              >
                Drawing
              </vs-checkbox>
            </div>
            <div class="vx-col w-1/2 mb-2">
              <vs-checkbox
                @change="updateQuestion()"
                :vs-value="'pdf'"
                v-model="specificFileTypes"
              >
                PDF
              </vs-checkbox>
            </div>
            <div class="vx-col w-1/2 mb-2">
              <vs-checkbox
                @change="updateQuestion()"
                :vs-value="'image'"
                v-model="specificFileTypes"
              >
                Image
              </vs-checkbox>
            </div>
            <div class="vx-col w-1/2">
              <vs-checkbox
                @change="updateQuestion()"
                :vs-value="'video'"
                v-model="specificFileTypes"
              >
                Video
              </vs-checkbox>
            </div>
            <div class="vx-col w-1/2">
              <vs-checkbox
                @change="updateQuestion()"
                :vs-value="'audio'"
                v-model="specificFileTypes"
              >
                Audio
              </vs-checkbox>
            </div>
          </div>
        </div>

        <label>Maximum number of files</label>
        <b-form-select
          v-model="maxFileNumber"
          :options="[1, 5, 10]"
          @change="updateQuestion()"
        ></b-form-select>
        <br />
        <br />
        <label class="">Maximum file size</label>
        <b-form-select
          v-model="maxFileSize"
          @change="updateQuestion()"
          :options="['1MB', '10MB', '100MB', '1GB', '10GB']"
        ></b-form-select>
      </div>

      <div
        v-else-if="['title_description'].includes(questionType)"
        class="mb-3"
      >
        <vs-textarea
          placeholder="Description"
          class="w-full"
          v-model="question_longdesc"
          @change="updateQuestion"
        />
      </div>

      <div
        v-if="
          [
            'company',
            'position',
            'website',
            'facebook_page_username',
            'line_id',
            'national_id',
            'student_id_card',
            'text'
          ].includes(questionType)
        "
        class="mb-3"
      >
        <vx-tooltip
          text="This answer will be pre-filled"
          style="display: inline"
          position="top"
        >
          <vs-input
            v-model="default_answer"
            @change="updateQuestion"
            class="mb-3"
            :placeholder="'Answer'"
            style="min-width: 600px"
            size="large"
          ></vs-input>
        </vx-tooltip>
      </div>
      <div v-if="['number'].includes(questionType)" class="mb-3">
        <vx-tooltip
          text="This answer will be pre-filled"
          class="test"
          style="display: inline"
          position="top"
        >
          <vs-input
            v-model="default_answer"
            type="number"
            @change="updateQuestion"
            class="mb-3"
            :placeholder="'Answer'"
            style="min-width: 600px"
            size="large"
          ></vs-input>
        </vx-tooltip>
      </div>
      <div v-if="['textarea'].includes(questionType)" class="mb-3">
        <vx-tooltip
          text="This answer will be pre-filled"
          style="display: inline"
          position="top"
        >
          <vs-textarea
            placeholder="Answer"
            class="w-full"
            v-model="default_answer"
            @change="updateQuestion"
          />
        </vx-tooltip>
      </div>

      <div v-if="['rank'].includes(questionType)" class="mb-3">
        <table>
          <tr>
            <td><h4>Rows</h4></td>
            <td><h4>Columns</h4></td>
          </tr>
          <draggable
            v-model="rankRows"
            :options="{
              animation: 300,
              handle: '.drag-handle'
            }"
            tag="td"
            style="vertical-align: top !important"
          >
            <tr
              class="drag-handle"
              v-for="(_, trindex) in rankRows.length"
              :key="trindex + `-rowrank`"
            >
              <div class="d-flex align-items-center mb-3">
                <div>
                  <h3 class="mb-0 mr-2">
                    <i class="fas fa-grip-vertical"></i>
                  </h3>
                </div>
                <div>
                  <vs-input
                    :ref="`rankrow-${trindex}`"
                    v-on:keyup.enter="addRankRows(trindex)"
                    v-model="rankRows[trindex]"
                    @change="updateQuestion"
                    class="mr-3"
                    :placeholder="'Row ' + (trindex + 1)"
                    style="
                      min-width: 300px;
                      border-bottom: 1px solid #6b6b6b !important;
                    "
                  ></vs-input>
                </div>
              </div>
            </tr>
          </draggable>

          <!-- <td style="vertical-align: top!important;">

          </td> -->

          <draggable
            v-model="rankColumns"
            :options="{
              animation: 300,
              handle: '.drag-handle'
            }"
            tag="td"
            style="vertical-align: top !important"
          >
            <tr
              class="drag-handle"
              v-for="(_, trindex) in rankColumns.length"
              :key="trindex + `-colrank`"
            >
              <div class="d-flex align-items-center mb-3">
                <div>
                  <h3 class="mb-0 mr-2">
                    <i class="fas fa-grip-vertical"></i>
                  </h3>
                </div>
                <div>
                  <vs-input
                    :ref="`rankcol-${trindex}`"
                    v-on:keyup.enter="addRankCols(trindex)"
                    v-model="rankColumns[trindex]"
                    @change="updateQuestion"
                    class="mr-3"
                    :placeholder="'Column ' + (trindex + 1)"
                    style="
                      min-width: 300px;
                      border-bottom: 1px solid #6b6b6b !important;
                    "
                  ></vs-input>
                </div>
              </div>
            </tr>
          </draggable>
        </table>

        <!-- <table>
          <tr>
            <td></td>
              <td v-for="col in rankColumns" :key="col+`-rank-header`">
                {{ col }}
              </td>
          </tr>
          <tr v-for="(row, rowindex) in rankRows" :key="row+`-rank`">
            <td>
              {{ row }}
            </td>
            <td v-for="col in rankColumns" :key="col+`-rank-`+rowindex">
              {{ col }}
            </td>
          </tr>
        </table> -->
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import draggable from "vuedraggable";
import ConditionSetting from "@/components/soldoutt/forms/ConditionSetting.vue";
const short = require("short-uuid");
const translator = short();

export default {
  components: { vSelect, draggable, ConditionSetting },
  props: {
    value: {
      type: Object,
      required: true
    },
    allQuestions: {
      type: Array,
      required: true
    },
    description_enabled: {
      type: Boolean
    },
    onNewQuestion: {
      type: Function
    },
    onCopyQuestion: {
      type: Function
    },
    onAddTitleDescription: {
      type: Function
    },
    onAddImage: {
      type: Function
    },
    onAddVideo: {
      type: Function
    },
    onAddDivider: {
      type: Function
    },
    onDelete: {
      type: Function
    },
    onMoveUp: {
      type: Function
    },
    onMoveDown: {
      type: Function
    }
  },
  data() {
    return {
      question: this.value.question_title,
      question_longdesc: this.value.question_longdesc,
      questionType: this.value.question_type,
      default_answer: this.value.default_answer || "",
      show: this.value.listing_status == 1,
      required: this.value.is_required ? this.value.is_required == 1 : false,
      is_description_enabled: this.value.description_enabled,
      description: this.value.question_shortdesc || "",
      radioOptions:
        this.value.options && this.value.options.length
          ? this.value.options
          : [{ value: "", actions: {} }], // Initial radio option
      otherOption: { value: "Other", is_other: true },
      checkboxOptions:
        this.value.options && this.value.options.length
          ? this.value.options
          : [{ value: "", actions: {} }],
      selectOptions:
        this.value.options && this.value.options.length
          ? this.value.options
          : [{ value: "", actions: {} }],
      questionTypes: [
        {
          label: "Frequently used",
          options: [
            { label: "Company", slug: "company", value: "company" },
            { label: "Position", slug: "position", value: "position" },
            { label: "Website", slug: "website", value: "website" },

            {
              label: "Facebook Page Username",
              slug: "facebook_page_username",
              value: "facebook_page_username"
            },
            { label: "LINE ID", slug: "line_id", value: "line_id" },
            { label: "National ID", slug: "national_id", value: "national_id" },
            {
              label: "Student ID Card",
              slug: "student_id_card",
              value: "student_id_card"
            },
            {
              label: "Province (Thailand)",
              slug: "province_thailand",
              value: "province_thailand"
            },
            { label: "Country", slug: "country", value: "country" },
            { label: "Birthdate", slug: "birthdate", value: "birthdate" }
          ]
        },
        {
          label: "Other Types",
          options: [
            { label: "Short answer", slug: "text", value: "text" },
            { label: "Number", slug: "number", value: "number" },
            { label: "Paragraph", slug: "textarea", value: "textarea" },
            { label: "Multiple choice", slug: "radio", value: "radio" },
            { label: "Checkboxes", slug: "checkbox", value: "checkbox" },
            { label: "Dropdown", slug: "select", value: "select" },
            { label: "File upload", slug: "file_upload", value: "file_upload" },
            { label: "Video", slug: "video", value: "video" },
            { label: "Rate", slug: "rate", value: "rate" },
            { label: "Rank", slug: "rank", value: "rank" },
            { label: "Date", slug: "date", value: "date" },
            { label: "Time", slug: "time", value: "time" },
            {
              label: "Title and Description",
              slug: "title_description",
              value: "title_description"
            },
            { label: "Divider", slug: "divider", value: "divider" }
          ]
        }
      ],
      rateMin: 1, // Initial min rate
      rateMax: 5, // Initial max rate
      rankRows:
        this.value.options &&
        this.value.options.rows &&
        this.value.options.rows.length
          ? this.value.options.rows
          : [""],
      rankColumns:
        this.value.options &&
        this.value.options.columns &&
        this.value.options.columns.length
          ? this.value.options.columns
          : [""],
      isSpecificFileTypes: false,
      specificFileTypes:
        this.value.options &&
        this.value.options &&
        this.value.options.specificFileTypes
          ? this.value.options.specificFileTypes
          : [],
      documentFileTypes: [".doc", ".docx", ".odt", ".rtf", ".pdf", ".txt"],
      presentationFileTypes: [".ppt", ".pptx", ".odp", ".pdf"],
      spreadsheetFileTypes: [".xls", ".xlsx", ".ods", ".csv"],
      drawingFileTypes: [".svg", ".dwg", ".ai"],
      pdfFileTypes: [".pdf"],
      imageFileTypes: [
        ".jpg",
        ".jpeg",
        ".png",
        ".gif",
        ".tif",
        ".tiff",
        ".bmp"
      ],
      videoFileTypes: [".avi", ".mp4", ".mpeg", ".mkv", ".mov", ".wmv"],
      audioFileTypes: [".mp3", ".wav", ".aac", ".wma"],
      maxFileNumber: this.value.options.maxFileNumber,
      maxFileSize: this.value.options.maxFileSize,
      sticking: false,
      sticking2: false,
      uploadMode: "",
      minCheckboxSelected: 0,
      maxCheckboxSelected: 0
    };
  },
  watch: {
    rateMin(newVal) {
      // Ensure that rateMin is always less than or equal to rateMax
      if (newVal > this.rateMax) {
        this.rateMax = newVal;
      }
    },
    rateMax(newVal) {
      // Ensure that rateMax is always greater than or equal to rateMin
      if (newVal < this.rateMin) {
        this.rateMin = newVal;
      }
    },
    questionType(newVal) {
      // Reset rate values when question type changes
      this.default_answer = "";
      if (newVal !== "rate") {
        this.rateMin = 1;
        this.rateMax = 5;
      }
    },
    description_enabled() {
      this.is_description_enabled = this.description_enabled;
    }
  },
  computed: {
    questionValue: {
      get() {
        return this.value;
      },
      set() {
        this.updateQuestion();
      }
    },
    flattenedQuestionTypes() {
      // Flatten the nested structure for v-select
      return this.questionTypes.flatMap(group => group.options);
    },
    showRemoveButton() {
      // Display the remove button if there are more than 1 items in radioOptions
      return this.radioOptions.length > 1;
    },
    showRemoveRadioButton() {
      // Display the remove button if there are more than 1 items in radioOptions
      return this.radioOptions.length > 1;
    },
    showRemoveCheckboxButton() {
      // Display the remove button if there are more than 1 items in radioOptions
      return this.checkboxOptions.length > 1;
    },
    showRemoveDropdownButton() {
      // Display the remove button if there are more than 1 items in radioOptions
      return this.selectOptions.length > 1;
    },
    showAddOtherButton() {
      // Check if there's already an "Other" option
      return !this.radioOptions.some(option => option.is_other);
    },
    showOtherOption() {
      // Check if there's already an "Other" option
      return this.radioOptions.some(option => option.is_other);
    },
    showAddCheckboxOtherButton() {
      // Check if there's already an "Other" option
      return !this.checkboxOptions.some(option => option.is_other);
    },
    showCheckboxOtherOption() {
      // Check if there's already an "Other" option
      return this.checkboxOptions.some(option => option.is_other);
    },
    showAddDropdownOtherButton() {
      // Check if there's already an "Other" option
      return !this.selectOptions.some(option => option.is_other);
    },
    showDropdownOtherOption() {
      // Check if there's already an "Other" option
      return this.selectOptions.some(option => option.is_other);
    },
    showRemoveOtherButton() {
      // Show remove button for "Other" option if it exists
      return this.showOtherOption;
    },
    radioOptionsForSelectedOption() {
      return [
        {
          text: "Choose pre-selected answer",
          value: ""
        },
        ...this.radioOptions.map(item => {
          return {
            text: item.value,
            value: item.value
          };
        })
      ];
    },
    selectOptionsForSelectedOption() {
      return [
        {
          text: "Choose pre-selected answer",
          value: ""
        },
        ...this.selectOptions.map(item => {
          return {
            text: item.value,
            value: item.value
          };
        })
      ];
    },
    checkboxOptionsForSelectedOption() {
      return [
        {
          text: "Choose pre-selected answer",
          value: ""
        },
        ...this.checkboxOptions.map(item => {
          return {
            text: item.value,
            value: item.value
          };
        })
      ];
    },
    allQuestionsNoThis() {
      return this.allQuestions.filter(
        item => item.question_uuid != this.value.question_uuid
      );
    }
  },
  mounted() {
    try {
      const observer = new IntersectionObserver(
        ([entry]) => {
          this.sticking = !entry.isIntersecting;
        },
        { threshold: 0.0 }
      );
      observer.observe(this.$refs.target);
      const observer2 = new IntersectionObserver(
        ([entry]) => {
          this.sticking2 = !entry.isIntersecting;
        },
        { threshold: 0.0 }
      );
      observer2.observe(this.$refs.target);
    } catch (_) {
      console.log();
    }
  },
  methods: {
    getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    uuid(n = 8) {
      var char = "";
      for (let i = 0; i < n; i += 1) {
        char += String.fromCharCode(this.getRandomInt(65, 90)); //alphanumeric chars
      }
      return char;
    },
    isRadioDuped(index) {
      if (this.radioOptions[index].value == "") {
        return false;
      }
      let dup = false;
      for (let i = 0; i < index; i++) {
        if (this.radioOptions[index].value == this.radioOptions[i].value) {
          dup = true;
          break;
        }
      }
      return dup;
    },
    isCheckboxDuped(index) {
      if (this.checkboxOptions[index].value == "") {
        return false;
      }
      let dup = false;
      for (let i = 0; i < index; i++) {
        if (
          this.checkboxOptions[index].value == this.checkboxOptions[i].value
        ) {
          dup = true;
          break;
        }
      }
      return dup;
    },
    isSelectDuped(index) {
      if (this.selectOptions[index].value == "") {
        return false;
      }
      let dup = false;
      for (let i = 0; i < index; i++) {
        if (this.selectOptions[index].value == this.selectOptions[i].value) {
          dup = true;
          break;
        }
      }
      return dup;
    },
    handleDragover(e) {
      e.stopPropagation();
      e.preventDefault();
      e.dataTransfer.dropEffect = "copy";
    },
    handleDrop(e) {
      e.stopPropagation();
      e.preventDefault();
      const files = e.dataTransfer.files;
      if (files.length !== 1) {
        this.$vs.notify({
          title: "Load failed",
          text: "Only support uploading one file!",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning"
        });
        return;
      }
      const rawFile = files[0]; // only use files[0]
      if (!this.isExcel(rawFile)) {
        this.$vs.notify({
          title: "Load failed",
          text: "Only supports upload .csv suffix files",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning"
        });
        return false;
      }
      this.uploadFile(rawFile);
    },
    readerDataForRadio(rawFile) {
      return new Promise(resolve => {
        const reader = new FileReader();
        reader.onload = e => {
          this.radioOptions = [];
          const data = e.target.result.replaceAll("\r", "").split("\n");
          for (var i = 0; i < data.length; i++) {
            this.radioOptions.push({
              value: data[i],
              actions: {}
            });
          }
          this.updateQuestion();
          resolve();
        };
        reader.readAsText(rawFile);
      });
    },
    readerDataForCheckbox(rawFile) {
      return new Promise(resolve => {
        const reader = new FileReader();
        reader.onload = e => {
          this.checkboxOptions = [];
          const data = e.target.result.replaceAll("\r", "").split("\n");
          for (var i = 0; i < data.length; i++) {
            this.checkboxOptions.push({
              value: data[i],
              actions: {}
            });
          }
          this.updateQuestion();
          resolve();
        };
        reader.readAsText(rawFile);
      });
    },
    handleClick(e) {
      const files = e.target.files;
      const rawFile = files[0];
      if (!rawFile) return;
      this.uploadFile(rawFile);
    },
    handleClickCheckboxes(e) {
      const files = e.target.files;
      const rawFile = files[0];
      if (!rawFile) return;
      this.uploadFileCheckboxes(rawFile);
    },
    isExcel(file) {
      return /\.(csv)$/.test(file.name);
    },
    uploadFile(file) {
      this.$refs["fileInput"].value = null; // fix can't select the same excel
      this.readerDataForRadio(file);
    },
    uploadFileCheckboxes(file) {
      this.$refs["fileInput"].value = null; // fix can't select the same excel
      this.readerDataForCheckbox(file);
    },
    updateQuestion() {
      let options = [];
      if (this.questionType == "radio") {
        options = this.radioOptions;
      }
      if (this.questionType == "checkbox") {
        options = this.checkboxOptions;
        let validations = [];
        if (
          this.value &&
          this.value.validations &&
          Array.isArray(this.value.validations)
        ) {
          validations = this.value.validations;
        }
        const minlengthindex = validations.findIndex(
          item => item.rule && item.rule == "minlength"
        );
        if (this.minCheckboxSelected && this.minCheckboxSelected > 0) {
          if (minlengthindex != -1) {
            validations[minlengthindex].value = parseInt(this.minCheckboxSelected) || 0;
          } else {
            validations.push({
              rule: "minlength",
              value: parseInt(this.minCheckboxSelected)
            });
          }
        } else if (minlengthindex != -1) {
          validations.splice(minlengthindex, 1);
        }

        const maxlengthindex = validations.findIndex(
          item => item.rule && item.rule == "maxlength"
        );
        if (this.maxCheckboxSelected && this.maxCheckboxSelected > 0) {
          if (maxlengthindex != -1) {
            validations[maxlengthindex].value = parseInt(this.maxCheckboxSelected) || 0;
          } else {
            validations.push({
              rule: "maxlength",
              value: parseInt(this.maxCheckboxSelected)
            });
          }
        } else if (maxlengthindex != -1) {
          validations.splice(maxlengthindex, 1);
        }
        this.value.validations = validations
      }
      if (this.questionType == "select") {
        options = this.selectOptions;
      }
      if (this.questionType == "rank") {
        options = {
          rows: this.rankRows.map(item => {
            return item ? item : "";
          }),
          columns: this.rankColumns.map(item => {
            return item ? item : "";
          })
        };
      }

      if (this.questionType == "file_upload") {
        let extensions = [];
        if (this.specificFileTypes.includes("document")) {
          extensions = extensions.concat(this.documentFileTypes);
        }
        if (this.specificFileTypes.includes("presentation")) {
          extensions = extensions.concat(this.presentationFileTypes);
        }
        if (this.specificFileTypes.includes("spreadsheet")) {
          extensions = extensions.concat(this.spreadsheetFileTypes);
        }
        if (this.specificFileTypes.includes("drawing")) {
          extensions = extensions.concat(this.drawingFileTypes);
        }
        if (this.specificFileTypes.includes("pdf")) {
          extensions = extensions.concat(this.pdfFileTypes);
        }
        if (this.specificFileTypes.includes("image")) {
          extensions = extensions.concat(this.imageFileTypes);
        }
        if (this.specificFileTypes.includes("video")) {
          extensions = extensions.concat(this.videoFileTypes);
        }
        if (this.specificFileTypes.includes("audio")) {
          extensions = extensions.concat(this.audioFileTypes);
        }
        options = {
          maxFileNumber: this.maxFileNumber,
          maxFileSize: this.maxFileSize,
          specificFileTypes: this.specificFileTypes,
          allowsExtensions: extensions
        };
      }
      this.$emit("input", {
        ...this.value,
        question_uuid: this.value.question_uuid || translator.new(),
        question_title: this.question,
        question_type: this.questionType,
        question_shortdesc: this.description,
        question_longdesc: this.question_longdesc,
        listing_status: this.show ? 1 : 0,
        is_required: this.required ? 1 : 0,
        options: options,
        default_answer: this.default_answer
      });
    },
    handleQuestionTypeChange() {
      const qt = this.questionTypes[0].options.find(
        item => item.slug == this.questionType
      );
      if (
        qt &&
        this.questionTypes[0].options.find(item => this.question == item.label)
      ) {
        this.question = qt.label;
      }
      // else {
      //   this.question = "";
      // }
      this.updateQuestion();
    },
    addRadioOption(index = -1) {
      // Add a new empty radio option
      if (index == -1) {
        this.radioOptions.push({
          value: "",
          actions: {}
        });
      } else {
        this.radioOptions.splice(index + 1, 0, {
          value: "",
          actions: {}
        });
      }
      // Move the "Other" option to the last item
      const otherIndex = this.radioOptions.findIndex(option => option.is_other);

      let lastindex = this.radioOptions.length - 1;
      if (otherIndex !== -1) {
        const otherOption = this.radioOptions.splice(otherIndex, 1)[0];
        this.radioOptions.push(otherOption);
        lastindex = this.radioOptions.length - 2;
      }
      lastindex = index == -1 ? lastindex : index + 1;
      this.updateQuestion();
      this.$nextTick(() => {
        this.$refs["radio-" + lastindex][0].focusInput();
      });
    },
    addOtherOption() {
      // Check if "Other" option already exists
      const otherIndex = this.radioOptions.findIndex(option => option.is_other);
      if (otherIndex === -1) {
        // Add "Other" option at the end of the array
        this.radioOptions.push({
          value: "Other",
          is_other: true,
          actions: {}
        });
      }
      this.updateQuestion();
    },
    isOtherOption(index) {
      // Check if the current option is "Other"
      return this.radioOptions[index] && this.radioOptions[index].is_other;
    },
    addCheckboxOtherOption() {
      // Check if "Other" option already exists
      const otherIndex = this.checkboxOptions.findIndex(
        option => option.is_other
      );
      if (otherIndex === -1) {
        // Add "Other" option at the end of the array
        this.checkboxOptions.push({
          value: "Other",
          is_other: true,
          actions: {}
        });
      }
      this.updateQuestion();
    },
    isCheckboxOtherOption(index) {
      // Check if the current option is "Other"
      return (
        this.checkboxOptions[index] && this.checkboxOptions[index].is_other
      );
    },
    addDropdownOtherOption() {
      // Check if "Other" option already exists
      const otherIndex = this.selectOptions.findIndex(
        option => option.is_other
      );
      if (otherIndex === -1) {
        // Add "Other" option at the end of the array
        this.selectOptions.push({
          value: "Other",
          is_other: true,
          actions: {}
        });
      }
      this.updateQuestion();
    },
    isDropdownOtherOption(index) {
      // Check if the current option is "Other"
      return this.selectOptions[index] && this.selectOptions[index].is_other;
    },
    removeRadioOption(index) {
      // Check if the index is valid
      if (index >= 0 && index < this.radioOptions.length) {
        // Remove the radio option at the specified index
        this.radioOptions.splice(index, 1);
        this.updateQuestion();
      }
    },
    removeOtherOption() {
      // Remove the "Other" option
      const otherIndex = this.radioOptions.findIndex(option => option.is_other);
      if (otherIndex !== -1) {
        this.radioOptions.splice(otherIndex, 1);
        this.updateQuestion();
      }
    },
    removeCheckboxOtherOption() {
      // Remove the "Other" option
      const otherIndex = this.checkboxOptions.findIndex(
        option => option.is_other
      );
      if (otherIndex !== -1) {
        this.checkboxOptions.splice(otherIndex, 1);
        this.updateQuestion();
      }
    },
    removeDropdownOtherOption() {
      // Remove the "Other" option
      const otherIndex = this.selectOptions.findIndex(
        option => option.is_other
      );
      if (otherIndex !== -1) {
        this.selectOptions.splice(otherIndex, 1);
        this.updateQuestion();
      }
    },
    addCheckboxOption(index = -1) {
      // Add a new empty radio option
      if (index == -1) {
        this.checkboxOptions.push({
          value: "",
          actions: {}
        });
      } else {
        this.checkboxOptions.splice(index + 1, 0, {
          value: "",
          actions: {}
        });
      }
      // Move the "Other" option to the last item
      const otherIndex = this.checkboxOptions.findIndex(
        option => option.is_other
      );

      let lastindex = this.checkboxOptions.length - 1;
      if (otherIndex !== -1) {
        const otherOption = this.checkboxOptions.splice(otherIndex, 1)[0];
        this.checkboxOptions.push(otherOption);
        lastindex = this.checkboxOptions.length - 2;
      }
      lastindex = index == -1 ? lastindex : index + 1;
      this.updateQuestion();
      this.$nextTick(() => {
        this.$refs["checkbox-" + lastindex][0].focusInput();
      });
    },
    removeCheckboxOption(index) {
      // Check if the index is valid
      if (index >= 0 && index < this.checkboxOptions.length) {
        // Remove the checkbox option at the specified index
        this.checkboxOptions.splice(index, 1);
      }
    },
    addSelectOption(index = -1) {
      // Add a new empty radio option
      if (index == -1) {
        this.selectOptions.push({
          value: "",
          actions: {}
        });
      } else {
        this.selectOptions.splice(index + 1, 0, {
          value: "",
          actions: {}
        });
      }
      // Move the "Other" option to the last item
      const otherIndex = this.selectOptions.findIndex(
        option => option.is_other
      );

      let lastindex = this.selectOptions.length - 1;
      if (otherIndex !== -1) {
        const otherOption = this.selectOptions.splice(otherIndex, 1)[0];
        this.selectOptions.push(otherOption);
        lastindex = this.selectOptions.length - 2;
      }
      lastindex = index == -1 ? lastindex : index + 1;
      this.updateQuestion();
      this.$nextTick(() => {
        this.$refs["select-" + lastindex][0].focusInput();
      });
    },
    removeSelectOption(index) {
      // Check if the index is valid
      if (index >= 0 && index < this.selectOptions.length) {
        // Remove the select option at the specified index
        this.selectOptions.splice(index, 1);
      }
    },
    addRankRows(index = -1) {
      // Add a new empty radio option
      if (index == -1) {
        this.rankRows.push("");
      } else {
        this.rankRows.splice(index + 1, 0, "");
      }

      let lastindex = this.rankRows.length - 1;
      lastindex = index == -1 ? lastindex : index + 1;
      this.updateQuestion();
      this.$nextTick(() => {
        this.$refs["rankrow-" + lastindex][0].focusInput();
      });
    },
    addRankCols(index = -1) {
      // Add a new empty radio option
      if (index == -1) {
        this.rankColumns.push("");
      } else {
        this.rankColumns.splice(index + 1, 0, "");
      }

      let lastindex = this.rankColumns.length - 1;
      lastindex = index == -1 ? lastindex : index + 1;
      this.updateQuestion();
      this.$nextTick(() => {
        this.$refs["rankcol-" + lastindex][0].focusInput();
      });
    }
  }
};
</script>

<style scoped>
/* Add your custom styles here */

/* Apply custom styles to the container */
.drag-handle i,
.radio-drag-handle i {
  color: rgb(98, 98, 98);
}
.question-wrapper .drag-handle,
.question-wrapper .btn-panel {
  opacity: 0;
  transition: width opacity ease 0.3s;
}
.question-wrapper:hover .drag-handle,
.question-wrapper:hover .btn-panel {
  opacity: 1;
}
.question-container {
  display: inline-flex;
  flex: 0 0 auto; /* shorthand for flex-grow: 0, flex-shrink: 0, flex-basis: auto */
  align-items: center;
  white-space: nowrap;
}

/* Style the left side */
.left-side {
  flex: 1;
  margin-right: 20px;
}

/* Style the rows in the left side */
.left-side-row {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

/* Style the Radio Options container */
.radio-options-container,
.checkbox-options-container,
.select-options-container {
  display: block;
  /* flex-wrap: wrap; */
}

/* Style each Radio Options item */
.radio-option,
.select-option,
.checkbox-option {
  display: flex;
  align-items: center;
  margin-right: 10px;
}

/* Style the dot */
.dot {
  margin-right: 5px;
}

/* Style the right side */
.right-side {
  flex: 1;
}

/* Add space on the left of the Add Option button */
.add-option-button {
  margin-left: 10px;
}

/* Style the remove button */
.remove-button {
  color: red;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
}

/* Style the container for Hide and Required */
.show-required-container {
  display: flex;
  align-items: center;
}
.drag-handle {
  cursor: grab;
  margin-right: 8px;
}
.radio-drag-handle i {
  cursor: grab;
  margin-right: 8px;
  opacity: 0;
  transition: opacity ease 0.1s;
}

.radio-drag-handle:hover i {
  opacity: 1;
}

.btn-panel {
  background: #f4f4f4;
  padding: 6px 6px;
  font-size: 1.5rem;
  border-radius: 2rem;
}
.btn-panel > div {
  padding: 4px 0;
}
.btn-panel i {
  font-size: 1.5rem;
  cursor: pointer;
  transition: all ease 0.1s;
}
.btn-panel i:hover {
  transform: scale(1.2);
}
.sticky-menu {
  background-color: #fff;
  padding: 1rem;
  position: sticky;
  top: 162px;
  z-index: 800;
}

.sticky-menu-2 {
  background-color: #fff;
  padding: 1rem;
  position: sticky;
  top: 122px;
  z-index: 800;
}

.sticky-menu {
  background-color: #fff;
  padding: 1rem;
  position: sticky;
  top: 182px;
  z-index: 800;
}

.sticky-menu .sticking {
  background-color: #fff;
  box-shadow: 0 8px 12px 0 rgba(0, 0, 0, 0.3);
}
</style>
